import { Alert, AlertTitle, Button, Typography } from '@mui/material'
import { observer } from 'mobx-react-lite'
import { useNavigate } from 'react-router-dom'
import { useStore } from '@hooks/useStore'

export const FreeTierBanner: React.FC = observer(() => {
  const { billing } = useStore()
  const navigate = useNavigate()

  // Don't show during loading (tier is null)
  if (billing.tier === null) return null

  // Only show for free tier users (not trial, not paid)
  if (billing.tier !== 'free') return null

  const documentsUsed = billing.monthlyDocumentsFinalized
  const documentsLimit = billing.limits?.monthly_documents || 5
  const documentsRemaining = documentsLimit - documentsUsed

  const getSeverity = (): 'error' | 'warning' | 'info' => {
    if (documentsRemaining === 0) return 'error'
    if (documentsRemaining <= 1) return 'warning'
    return 'info'
  }

  const getTitle = (): string => {
    if (documentsRemaining === 0) {
      return 'Documentlimiet bereikt'
    }
    return `${documentsUsed} van ${documentsLimit} documenten gebruikt`
  }

  const getMessage = (): string => {
    if (documentsRemaining === 0) {
      return 'Upgrade naar PRO voor onbeperkte documenten, e-mail verzending en meer.'
    }
    const docWord = documentsRemaining === 1 ? 'document' : 'documenten'
    return `Je hebt nog ${documentsRemaining} ${docWord} over deze maand. ` +
      'Upgrade naar PRO voor onbeperkte documenten.'
  }

  return (
    <Alert
      severity={getSeverity()}
      sx={{ mb: 3 }}
      action={
        <Button
          color="inherit"
          size="small"
          variant="outlined"
          onClick={() => navigate('/instellingen?tab=subscription')}
        >
          Upgrade naar PRO
        </Button>
      }
    >
      <AlertTitle>{getTitle()}</AlertTitle>
      <Typography variant="body2">{getMessage()}</Typography>
    </Alert>
  )
})
